/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import ProductSlider from "./ProductSlider.container";

export default ProductSlider;
